import React from "react";

import { TableCell, TableHead, TableRow, Checkbox } from "@material-ui/core";

const headCells = [
  { id: "customer", label: "customer" },
  { id: "email", label: "email" },
  { id: "phone", label: "phone number" },
  // { id: "last_purchase", label: "last purchase", numeric: true },
  { id: "actions", label: "actions", numeric: true }
];

const CustomTableHead = ({ exclude=[], onSelectAllClick, numSelected, rowCount }) => {
  return (
    <TableHead className="bg-transparent">
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox 
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
            className=""
          />
        </TableCell>
        {headCells.filter(({id}) => !exclude.includes(id)).map((cell) => (
          <TableCell
            key={cell.id}
            className="uppercase text-[12px]"
            align={cell.numeric ? "right" : "left"}
          >
            {cell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default CustomTableHead;
